module.exports = __webpack_public_path__ + "static/media/quarrytruck3_preview.a7c2ba6e.jpg";